import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import './app.css';
import Canvas from './components/flowChart';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import GitHub from '@mui/icons-material/GitHub';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import images from "./components/images";
import Joyride from 'react-joyride';

const theme = createTheme({
  palette: {
    neutral: {
      main: '#808080',

    },
  },
});

function App() {
  const [showTemplateNav, setShowTemplateNav] = useState(false)
  const [showJoyride, setshowJoyride] = useState(true);

  const steps = [
    {
      target: '.prebake-template',
      content: 'You can start by adding a prebaked template',
      disableBeacon: true
    },
    {
      target: '.draggable-stack',
      content: 'Or you build from scratch by dragging these components to canvas',
      disableBeacon: true
    },
  ]

  return (
    <div className="App">
      <Joyride
        steps={steps}
        run={showJoyride}
        scrollToFirstStep
        showProgress
        showSkipButton
        continuous
        hideCloseButton
      />
      <div className="App-header">
        <div style={{
          display: 'flex', alignItems: "center", position: "fixed",
          left: "40%"
        }}>
          <img
            src={images.KriusLogo}
            height="40px"
            width="45px"
            style={{ borderRight: "1px solid #d9d9d9" }}
          />
          <span className='app-heading'>
            Krius UI- a simple tool to create monitoring flow chart for your K8s cluster
          </span>
        </div>
        <IconButton
          href="https://github.com/infracloudio/krius"
          aria-label="close"
          target="_blank"
          sx={{
            position: 'absolute',
            right: 10,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <GitHub />
        </IconButton>

        <ThemeProvider theme={theme}>
          <Button variant="outlined" style={{
            height: 28,
            textTransform: 'capitalize',
            fontWeight: 'bold',
            position: "absolute",
            right: 60,
            top: 16,
          }}
            className="prebake-template"
            color="neutral"
            onClick={() => setShowTemplateNav(!showTemplateNav)}
          >
            Add a Prebaked Template
          </Button>

        </ThemeProvider>
      </div>
      <Canvas showTemplateNav={showTemplateNav} setShowTemplateNav={setShowTemplateNav} />

    </div >
  );
}

export default App;
